"use client";
import { Sponsor } from "@/common/course/types";
import Image from "next/image";
import React from "react";
import useTranslations from "@/i18n/useTranslations";

interface SponsorsProps {
  sponsors: Sponsor[];
  containerClassName?: string;
  titleClassName?: string;
}

export default function Sponsors({
  sponsors,
  containerClassName = "",
  titleClassName = "",
}: SponsorsProps) {
  const t = useTranslations("Common");

  return (
    <div className={containerClassName}>
      <h3 className={titleClassName}>{t("sponsors")}</h3>
      {sponsors.map((sponsor: Sponsor) => (
        <div key={sponsor.name} className="flex flex-col md:flex-row gap-4">
          {sponsor.logoImageUrl ? (
            <div className="">
              <Image
                src={sponsor.logoImageUrl}
                alt={sponsor.name || t("sponsorLogo")}
                title={sponsor.name}
                width={170}
                height={85}
                className="max-w-none"
              />
            </div>
          ) : null}
          <p className="break-keep">
            {t("sponsorContribution", { name: sponsor.name })}
          </p>
        </div>
      ))}
    </div>
  );
}
